module.exports = __webpack_public_path__ + "img/179.7128ac4f.jpg";